import React from "react";
import { connect } from "react-redux";
import { ProductWarranteeContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import moment from "moment-timezone";
import { MdAdd } from "react-icons/md";
import queryString from "query-string";
import { portalService } from "apiServices";
import {
  RENDER_WARRANTY_STATUS,
  RENDER_STATUS_PRODUCT_WARRANTY,
} from "utils/functions/productWarranty";
import { Buttons, Inputs, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class ProductWarranteeContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
    productDepOptions: [],
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.renderFilter();
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
    this.fetchOptions();
  }

  fetchData = async (stringQuery) => {
    let res = await portalService.GET_PRODUCT_WARRANTEE_LIST(stringQuery);
    if (res && res.status === 200) {
      this.setState({
        data: res.data.docs,
        isLoading: false,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
      });
    }
  };

  fetchOptions = async () => {
    let res = await portalService.GET_PRODUCT_DEP_LIST(`?pagination=false`);
    if (res && res.status === 200) {
      this.setState({
        productDepOptions: [
          { label: "All", value: "" },
          ...res.data.docs.map((e) => ({
            label: e.code,
            value: e.code,
          })),
        ],
      });
    }
  };

  renderFilter = () => {
    const query = this.props.router.location.search;
    if (query) {
      let initialValues = queryString.parse(query);
      if (Object.keys(initialValues).length > 0) {
        let queryTemp = Object.keys(initialValues)
          .filter((e) => e !== "page" && e !== "limit")
          .map((f) => `${f}=${initialValues[f]}`)
          .join("&");
        if (queryTemp) {
          this.setState({
            filterQuery: `?${queryTemp}`,
          });
        }
      }
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleClickCreate = (e) => {
    if (e === "create") {
      this.props.router.navigate(`${ROUTE_PATH.PRODUCT_WARRANTY}/new/create`);
    } else {
      this.props.router.navigate(`${ROUTE_PATH.PRODUCT_WARRANTY}/${e}`);
    }
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.PRODUCT_WARRANTY}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  handleExport = async () => {
    const { filterQuery } = this.state;
    this.setState({
      isBgLoading: true,
      exportProgress: "กำลังเตรียมไฟล์... 0%",
    });
    try {
      // Pseudo-progress curve: streaming response has no Content-Length, so we
      // map loaded bytes onto an asymptotic curve toward 95%, then snap to
      // 100% when the stream closes. K controls how fast the curve climbs;
      // 5 MB roughly matches a small/medium export feeling responsive.
      const PROGRESS_K = 5 * 1048576;
      const stringQuery = filterQuery || "";
      const blob = await portalService.DOWNLOAD_PRODUCT_WARRANTEE_EXCEL(
        stringQuery,
        ({ loaded }) => {
          const pct = Math.min(
            95,
            Math.floor((loaded / (loaded + PROGRESS_K)) * 95),
          );
          this.setState({ exportProgress: `กำลังดาวน์โหลด... ${pct}%` });
        },
      );
      if (blob && blob instanceof Blob) {
        this.setState({ exportProgress: "กำลังบันทึกไฟล์... 100%" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `product-warrantee-report-${moment()
          .tz("Asia/Bangkok")
          .format("DD-MM-YYYY")}.xlsx`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.log("export error =>", err);
    } finally {
      this.setState({
        isBgLoading: false,
        exportProgress: null,
      });
    }
  };

  render() {
    const { authenRedux, router } = this.props;
    const {
      isLoading,
      isBgLoading,
      exportProgress,
      pagination,
      data,
      productDepOptions,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "product_warranty");
    return (
      <ProductWarranteeContainerStyled>
        <Displays.BGLoading
          theme_standard_loading
          visible={isBgLoading}
          message={exportProgress}
          timeout={0}
        />
        {permission && permission.is_create && (
          <div className="btn_create">
            <div className="w120">
              <Buttons.BgIconPrefix
                label="New"
                icon={<MdAdd size={18} />}
                onClick={() => this.handleClickCreate("create")}
              />
            </div>
          </div>
        )}
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search, productDepOptions)}
          permission={permission}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
          onExport={
            permission &&
            (permission.is_export || permission.is_export_condition)
              ? () => this.handleExport()
              : false
          }
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table  ">
              <Tables.Standard
                columns={columns({
                  handleClickDetail: this.handleClickCreate,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </ProductWarranteeContainerStyled>
    );
  }
}

const dataFilter = (query, productDepOptions) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "serial_no",
      length: "311px",
      filter: {
        fieldQuery: "serial_no",
        defaultValue: initialValues["serial_no"],
        type: "text",
        label: "SN search",
        placeholder: "Serial no",
      },
    },
    {
      accessor: "item_no",
      length: "311px",
      filter: {
        fieldQuery: "item_no",
        defaultValue: initialValues["item_no"],
        type: "text",
        label: "Item No search",
        placeholder: "Item no",
      },
    },
    {
      accessor: "status",
      length: "311px",
      filter: {
        fieldQuery: "status",
        defaultValue: initialValues["status"],
        type: "dropdown",
        label: "Status",
        placeholder: "",
        options: [
          {
            label: "All",
            value: "",
          },
          {
            label: "Ready",
            value: "1",
          },
          {
            label: "Wait Approve",
            value: "2",
          },
          {
            label: "Approved",
            value: "3",
          },
          // {
          //   label: 'Expired',
          //   value: '4',
          // },
          {
            label: "Rejected",
            value: "5",
          },
        ],
      },
    },
    {
      accessor: "warranty_status",
      length: "311px",
      filter: {
        fieldQuery: "warranty_status",
        defaultValue: initialValues["warranty_status"],
        type: "dropdown",
        label: "Warranty Status",
        placeholder: "",
        options: [
          {
            label: "All",
            value: "",
          },
          {
            label: "None",
            value: "1",
          },
          {
            label: "Under Warranty",
            value: "2",
          },
          {
            label: "Warranty Expired",
            value: "3",
          },
          {
            label: "Warranty Cancel",
            value: "4",
          },
        ],
      },
    },
    {
      accessor: "pd_dep_code",
      length: "311px",
      filter: {
        fieldQuery: "pd_dep_code",
        defaultValue: initialValues["pd_dep_code"],
        type: "dropdown",
        label: "Product Dep.",
        placeholder: "",
        options: productDepOptions,
      },
    },
    {
      accessor: "is_member",
      length: "311px",
      filter: {
        fieldQuery: "is_member",
        defaultValue: initialValues["is_member"],
        type: "dropdown",
        label: "ประเภทการลงทะเบียน",
        placeholder: "",
        options: [
          {
            label: "All",
            value: "",
          },
          {
            label: "แบบเป็นสมาชิก",
            value: "true",
          },
          {
            label: "แบบไม่เป็นสมาชิก",
            value: "false",
          },
        ],
      },
    },
    {
      accessor: "created_at",
      length: "311px",
      filter: {
        fieldQuery: "created_at",
        defaultValue:
          initialValues["start_date"] && initialValues["end_date"]
            ? {
                startDate: new Date(initialValues["start_date"]),
                endDate: new Date(initialValues["end_date"]),
              }
            : false,
        type: "dateRank",
        placeholder: "เลือกวันที่",
      },
    },
  ];
};

const columns = ({ handleClickDetail }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {moment(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Sn</div>,
    accessor: "serial_no",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Item no</div>,
    accessor: "item_no",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Description</div>,
    accessor: "description",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}{" "}
        {props.row.original.description_line_2 === null
          ? ""
          : props.row.original.description_line_2}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Dealer Code</div>,
    accessor: "dealer_code",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Dealer Name</div>,
    accessor: "dealer_name",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Invoice date</div>,
    accessor: "invoice_date",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value && `${moment(props.value).format("DD/MM/YYYY")}`}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Registed at</div>,
    accessor: "registed_at",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {props.value && `${moment(props.value).format("DD/MM/YYYY")}`}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "center" }}>Status</div>,
    accessor: "status",
    Cell: (props) => {
      const renderStatus = RENDER_STATUS_PRODUCT_WARRANTY(props.value);
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Displays.StatusLabel
            bg={renderStatus?.bg}
            label={renderStatus?.label}
          />
        </div>
      );
    },
  },
  {
    Header: <div style={{ textAlign: "left" }}>Warranty</div>,
    accessor: "warranty_status",
    Cell: (props) => {
      const renderStatus = RENDER_WARRANTY_STATUS(props.value);
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Displays.StatusLabel
            bg={renderStatus?.bg}
            label={renderStatus?.label}
          />
        </div>
      );
    },
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ProductWarranteeContainer));
